import { createSlice } from '@reduxjs/toolkit';
/*
// Safely read the initial value from localStorage (browser only)
const getInitialView = () => {
  if (typeof window === 'undefined') {
    return 'bar';
  }
  const stored = window.localStorage.getItem('imperfectionChartView');
  return stored === 'bar' ? 'bar' : 'radar';
};*/
// Set default value as Bar
const initialState = {
  view: "bar",
};

export const imperfectionChartViewReducer = createSlice({
  name: 'imperfectionChartView',
  initialState,
  reducers: {
    setImperfectionView: (state, action) => {
      //default to set the chart graph as bar
      if(action.payload == null)
          action.payload = 'bar';

      state.view = action.payload === 'bar' ? 'bar' : 'radar';
    },
  },
});

export const { setImperfectionView } = imperfectionChartViewReducer.actions;

export default imperfectionChartViewReducer.reducer;


